import logoFoxBusiness from '../../assets/press_logo_fox_business.jpg';
import logoMotley from '../../assets/press_logo_motleytext.png';
import logoWSJ from '../../assets/press_logo_wsj.jpg';

export default [
  {
    name: 'Fox Business', // Not very important, mostly internal.
    quote: `“RealtyMogul is breaking down barriers by connecting
      investors with major real estate projects.”`,
    logoImage: logoFoxBusiness,
    weight: 3,
  },
  {
    name: 'Motley Fool', // Not very important, mostly internal.
    quote: `“Altogether, RealtyMogul has a lot to offer investors across different
      wealth levels…its due diligence process is one of the best.”`,
    logoImage: logoMotley,
    weight: 2,
  },
  {
    name: 'Wall Street Journal', // Not very important, mostly internal.
    quote: `“RealtyMogul lets investors browse, conduct due diligence, invest and
      track the performance of their investments through an online dashboard.”`,
    logoImage: logoWSJ,
    weight: 1,
  },
];
